import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import TurnstileFallbackOverlay from '../Components/Captcha/TurnstileFallbackOverlay';
import { history } from '../Routes/history';

export const CaptchaFallbackContext = createContext(null);

export const CaptchaFallbackProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const resolverRef = useRef(null);

  const resolveFallback = useCallback(token => {
    if (resolverRef.current) {
      resolverRef.current(token);
      resolverRef.current = null;
    }
    setOpen(false);
  }, []);

  const requestFallbackToken = useCallback(action => {
    setHasError(false);
    setCurrentAction(action);
    setOpen(true);
    return new Promise(resolve => {
      resolverRef.current = resolve;
    });
  }, []);

  const handleResolved = useCallback(
    token => {
      resolveFallback(token);
    },
    [resolveFallback]
  );

  const handleError = useCallback(() => {
    setHasError(true);
  }, []);

  // Auto-close on navigation so the overlay doesn't persist on the new page
  useEffect(() => {
    const unlisten = history.listen(() => {
      resolveFallback(null);
    });
    return unlisten;
  }, [resolveFallback]);

  return (
    <CaptchaFallbackContext.Provider value={{ requestFallbackToken }}>
      {children}
      <TurnstileFallbackOverlay
        open={open}
        error={hasError}
        action={currentAction}
        onResolved={handleResolved}
        onError={handleError}
      />
    </CaptchaFallbackContext.Provider>
  );
};
